import React, { useCallback, useEffect, useState } from 'react'
import { Table, Badge } from 'react-bootstrap'
import useMapper from './use-mapper'
import Selector from './selector'
import ColumnsSelector from './columns-selector'
import Checkbox from '../../../common/checkbox'
import isEmailValid from '../../../../utilities/is-email-valid'

const RecordColumMapper = ({
    records = [],
    onChange = () => {},
}) => {

    const [ errors, setErrors ] = useState([])
    const [ warnings, setWarnings ] = useState([])

    const onMap = useCallback(users => {
        onChange(errors.length ? [] : users)
    }, [onChange, errors])

    const {
        columnTypeOptions,
        setColumnType,
        getColumnType,
        columnsSelected,
        setColumnsSelected,
        selectRow,
        rowSelected,
        columnMap,
    } = useMapper({ records, onMap })

    useEffect(() => {
        const columns = Object.values(columnMap)
        const errors = []
        const warnings = []
        if (!columns.includes('email')) {
            errors.push('Email')
        }
        if (!columns.includes('firstName')) {
            errors.push('First Name')
        }
        if (!columns.includes('lastName')) {
            errors.push('Last Name')
        }
        if (!columns.includes('studentId')) {
            warnings.push('Student ID')
        }
        if (!columns.includes('gradYear')) {
            warnings.push('Graduation Year or Grade Level')
        }
        setErrors(errors)
        setWarnings(warnings)
    }, [columnMap])

    const renderColumnSelector = (columnIndex, key) => {
        const columnName = columnIndex.toString()
        return (
            <th key={key}>
                <Selector
                    options={columnTypeOptions}
                    value={getColumnType(columnIndex)}
                    onChange={type => setColumnType(columnIndex, type)}
                />
            </th>
        )
    }

    const renderColumn = (column, index) => {
        if (!columnsSelected.includes(index)) {
            return null
        }
        return (
            <td key={index}>{column}</td>
        )
    }

    const renderRecord = (record = [], index) => {
        const recordIsValid = record.some(isEmailValid)
        const checked = rowSelected(index) && recordIsValid
        return (
            <tr key={index} style={{ backgroundColor: !checked ? 'rgb( 236, 236, 236) ' : undefined }}>
                <td>
                    <Checkbox disabled={!recordIsValid} checked={checked} onChange={selected => selectRow(index, selected)} />
                </td>
                {record.map(renderColumn)}
            </tr>
        )
    }

    const renderRecords = () => {
        if (!columnsSelected.length) {
            return (<tr><td>Please select columns</td></tr>)
        }

        if (!records.length) {
            return (<tr><td>No records found.</td></tr>)
        }

        return records.map(renderRecord)
    }

    const renderWarning = (text, key) => (<Badge style={{ marginLeft: '5px'}} key={key} variant="warning">{text}</Badge>)
    const renderError = (text, key) => (<Badge style={{ marginLeft: '5px'}} key={key} variant="danger">{text}</Badge>)
    const renderGood = () => {
        if (errors.length || warnings.length) {
            return null
        }
        return (
            <Badge style={{ marginLeft: '5px'}} variant="success">None!</Badge>
        )
    }

    return (
        <div>
            <div style={{ paddingTop: '20px'}}>
                <label>Included columns:</label>
                <ColumnsSelector
                    records={records}
                    values={columnsSelected}
                    onChange={setColumnsSelected}
                />
            </div>
            <div style={{ paddingTop: '20px', display: columnsSelected.length ? '' : 'none'}}>
                <label>
                    <div>Records:</div>
                    <div>
                        <span className='text-muted'>Issues:</span>
                        {errors.map(renderError)}
                        {warnings.map(renderWarning)}
                        {renderGood()}
                    </div>
                </label>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <Table bordered={columnsSelected.length && records.length} hover={columnsSelected.length && records.length} >
                        <thead>
                            <tr>
                                <th style={{ width: '10px'}}></th>
                                {Array.from(Array(columnsSelected.length).keys()).map(renderColumnSelector)}
                            </tr>
                        </thead>
                        <tbody>{renderRecords()}</tbody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export default RecordColumMapper